import { LoadingButton } from '@atlaskit/button';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { useDevopsState } from '../../hook';
import { messages } from '../../messages';
import { fontCharlieText } from '../styled';

type ButtonSubmitType = {
  isLoading: boolean;
  isDisabled: boolean;
};

export function ButtonSubmit({ isLoading, isDisabled }: ButtonSubmitType) {
  const { userInfo } = useDevopsState();

  function SubmitButtonMessage() {
    switch (userInfo?.isLoggedIn) {
      case true:
        return (
          <SanitizedFormattedHtmlMessage {...messages.submitButtonLoggedIn} />
        );
      default:
        return (
          <SanitizedFormattedHtmlMessage {...messages.submitButtonLoggedOut} />
        );
    }
  }

  return (
    <StyledButton
      type="submit"
      appearance="primary"
      testId="devops-button-submit"
      isLoading={isLoading}
      isDisabled={isDisabled || isLoading}
      shouldFitContainer
    >
      <SubmitButtonMessage />
    </StyledButton>
  );
}

const StyledButton = styled(LoadingButton)`
  font-family: ${fontCharlieText};
  font-weight: 500;
  padding: 0 8px;
  margin-top: 30px;
  width: 100%;
  text-align: center;

  span {
    margin: auto;
  }

  svg {
    margin-bottom: 0px;
  }
`;
